export { ApplicantActions } from './ApplicantActions/ApplicantActions';
export { ApplicantAttachments } from './ApplicantAttachments';

export enum DrawerComponentsEnum {
  ApplicantAttachments = 'ApplicantAttachments',
  ApplicantActions = 'ApplicantActions',
}
